import { UserStore } from 'app/core/user/user.types';

// user state

export interface UserState {
  user: UserStore | null;
  connectedUser: UserStore | null;
}

export const initialUserState: UserState = {
  user: null,
  connectedUser: null
};

// app state

export interface AppState {  
  user: UserState;  
}

export const initialAppState: AppState = {  
  user: initialUserState  
};
